__turbopack_context__.v({
  "addToBag": "ProductInfo-module-scss-module__gfBSDq__addToBag",
  "affirmSentence": "ProductInfo-module-scss-module__gfBSDq__affirmSentence",
  "boutiquePickup": "ProductInfo-module-scss-module__gfBSDq__boutiquePickup",
  "boutiqueText": "ProductInfo-module-scss-module__gfBSDq__boutiqueText",
  "breadcrumbs": "ProductInfo-module-scss-module__gfBSDq__breadcrumbs",
  "breadcrumbsWrapper": "ProductInfo-module-scss-module__gfBSDq__breadcrumbsWrapper",
  "callToBuyCta": "ProductInfo-module-scss-module__gfBSDq__callToBuyCta",
  "cembraSentence": "ProductInfo-module-scss-module__gfBSDq__cembraSentence",
  "ctaIcon": "ProductInfo-module-scss-module__gfBSDq__ctaIcon",
  "ctas": "ProductInfo-module-scss-module__gfBSDq__ctas",
  "currentStrap": "ProductInfo-module-scss-module__gfBSDq__currentStrap",
  "engravingCta": "ProductInfo-module-scss-module__gfBSDq__engravingCta",
  "engravingCtaSpacing": "ProductInfo-module-scss-module__gfBSDq__engravingCtaSpacing",
  "findStrapButton": "ProductInfo-module-scss-module__gfBSDq__findStrapButton",
  "galletBookAppointment": "ProductInfo-module-scss-module__gfBSDq__galletBookAppointment",
  "galletPerk": "ProductInfo-module-scss-module__gfBSDq__galletPerk",
  "galletPerkCheck": "ProductInfo-module-scss-module__gfBSDq__galletPerkCheck",
  "galletPerkTitle": "ProductInfo-module-scss-module__gfBSDq__galletPerkTitle",
  "galletPerks": "ProductInfo-module-scss-module__gfBSDq__galletPerks",
  "galletSecondaryActions": "ProductInfo-module-scss-module__gfBSDq__galletSecondaryActions",
  "giftButtonContent": "ProductInfo-module-scss-module__gfBSDq__giftButtonContent",
  "giftIcon": "ProductInfo-module-scss-module__gfBSDq__giftIcon",
  "giveAsGift": "ProductInfo-module-scss-module__gfBSDq__giveAsGift",
  "header": "ProductInfo-module-scss-module__gfBSDq__header",
  "info": "ProductInfo-module-scss-module__gfBSDq__info",
  "infoIcon": "ProductInfo-module-scss-module__gfBSDq__infoIcon",
  "linkIcon": "ProductInfo-module-scss-module__gfBSDq__linkIcon",
  "name": "ProductInfo-module-scss-module__gfBSDq__name",
  "oneySentence": "ProductInfo-module-scss-module__gfBSDq__oneySentence",
  "orDivider": "ProductInfo-module-scss-module__gfBSDq__orDivider",
  "orLine": "ProductInfo-module-scss-module__gfBSDq__orLine",
  "orText": "ProductInfo-module-scss-module__gfBSDq__orText",
  "perk": "ProductInfo-module-scss-module__gfBSDq__perk",
  "perkIconWrapper": "ProductInfo-module-scss-module__gfBSDq__perkIconWrapper",
  "perkTitle": "ProductInfo-module-scss-module__gfBSDq__perkTitle",
  "perks": "ProductInfo-module-scss-module__gfBSDq__perks",
  "preOrderInfo": "ProductInfo-module-scss-module__gfBSDq__preOrderInfo",
  "price": "ProductInfo-module-scss-module__gfBSDq__price",
  "priceRow": "ProductInfo-module-scss-module__gfBSDq__priceRow",
  "pricing": "ProductInfo-module-scss-module__gfBSDq__pricing",
  "secondaryLink": "ProductInfo-module-scss-module__gfBSDq__secondaryLink",
  "secondaryLinks": "ProductInfo-module-scss-module__gfBSDq__secondaryLinks",
  "selectorsRow": "ProductInfo-module-scss-module__gfBSDq__selectorsRow",
  "sku": "ProductInfo-module-scss-module__gfBSDq__sku",
  "strapImage": "ProductInfo-module-scss-module__gfBSDq__strapImage",
  "strapSelector": "ProductInfo-module-scss-module__gfBSDq__strapSelector",
  "taxNote": "ProductInfo-module-scss-module__gfBSDq__taxNote",
  "v12Sentence": "ProductInfo-module-scss-module__gfBSDq__v12Sentence",
});
